import {GeoJSON, WKT} from 'ol/format';
import { navigationLayers } from '../mapNavigator/layers.js';
import store from '../../store';

export const geojsonFormat = new GeoJSON();
export const wktFormat = new WKT();
export const TOOLTIP_ID = 'mep-tooltip';

export const loadingWorkingAreaMsg = `Please wait while you're working area is being loaded`;

export const outsideWorkingAreaMsg = `
    <div>You are not allowed to use this tool outside your working area.</div>
    <div><strong>Note:</strong> Turn on the working area layer to view your working area.</div>
`;

export const selectAppropriateMuniMsg = `
    First, select a municipality within your working area to use the tool.
`;

export const inWorkingAreaButOutsideMunicipalityMsg = `
    Use the tool inside the selected municipality
`;

export const isInsideWorkingArea = coordinate =>
{
    const workingAreaFeatures = store.getters['tools/getWorkingAreaFeatures'];
    return workingAreaFeatures.some(
        feature => feature.getGeometry().intersectsCoordinate(coordinate)
    );
};

export const getSelectedMunicipality = () =>
{
    const features = navigationLayers.soloMunicipality.getSource().getFeatures();
    return features.length > 0 && features[0];
}

export const municipalityIsSelected = () =>
{
    return Boolean(getSelectedMunicipality());
};

export const selectedMunicipalityInsideWorkingArea = () =>
{
    const municipalityFeature = getSelectedMunicipality();
    if (municipalityFeature)
    {
        const coordinate = municipalityFeature.getGeometry().getInteriorPoints().getFirstCoordinate();
        const workingAreaFeatures = store.getters['tools/getWorkingAreaFeatures'];
        return workingAreaFeatures.some(feature => feature.getGeometry().intersectsCoordinate(coordinate));
    }
    return false;
};

export const isInPlanMunicipality = coordinate => 
{
    const municipalityFeature = store.getters['plan/getMunicipalityFeature'];
    if (municipalityFeature)
    {
        return municipalityFeature.getGeometry().intersectsCoordinate(coordinate);    
    }
};


export const isInSelectedMuncipality = coordinate =>
{
    const municipality = getSelectedMunicipality();
    return municipality && municipality.getGeometry().intersectsCoordinate(coordinate);
};

export const getWorkingAreaRestrictedMsg = (coordinate, msg) =>
{
    const workingAreaIsLoaded = store.getters['tools/isWorkingAreaLoaded'];
    return !workingAreaIsLoaded ? loadingWorkingAreaMsg :
        !isInsideWorkingArea(coordinate) ? outsideWorkingAreaMsg :
        (!municipalityIsSelected() || !selectedMunicipalityInsideWorkingArea()) ? selectAppropriateMuniMsg :
        !isInSelectedMuncipality(coordinate) ? inWorkingAreaButOutsideMunicipalityMsg :
        msg;
}

export const getPlanRestrictedMsg = (coordinate, msg) =>
{
    return !isInSelectedMuncipality(coordinate) && !isInPlanMunicipality(coordinate) ?
        'Please draw inside the plan\'s municipality'
        :
        msg;
}

const getToolTipElement = () =>
{
    return document.getElementById(TOOLTIP_ID);
}

export const toolTipIsVisible = () =>
{
    const toolTipElement = getToolTipElement();
    return toolTipElement && toolTipElement.style.display!=='none';
};

export const addToolTipBase = (map, getMessage, {showOnly=false}={}) =>
{
    const toolTipElement = getToolTipElement();
    toolTipElement.style.display = 'block';
    if (showOnly) return;

    const toolTipHover = map.on('pointermove', async event =>
    {
        toolTipElement.innerHTML = getMessage(event.coordinate);
        toolTipElement.style.opacity = 1;
        toolTipElement.style.left = `${event.pixel[0]}px`;
        toolTipElement.style.top = `${event.pixel[1]}px`;
    });
    return toolTipHover;
};

export const clearToolTipBase  = ({hideOnly=false}={}) =>
{
    const toolTipElement = getToolTipElement();
    if (toolTipElement)
    {
        toolTipElement.style.display = 'none';
        if (hideOnly) return;

        toolTipElement.innerText = "";
    }
}